import { isEmpty, isString } from 'lodash';

export default id => !isEmpty(id) && isString(id);
